module.exports = __webpack_public_path__ + "images/left-7e3dff9c5f6f57bee6ab1f107058b48e.png";